import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
import { TypePlanoContasTipo } from "../../Models/Financeiro/PlanoContasTipo";
import { TypeRegistro } from "../../Models/Financeiro/PlanoContasTipoRegistro";

export class PlanoContasTipoService {
    public listarTipo(tipo: TypePlanoContasTipo): Promise<AxiosResponse<TypePlanoContasTipo[]>> {
        return Axios.post<TypePlanoContasTipo[]>(`PlanoContasTipo/listarTipo`, tipo);
    }

    public listarClassificacao(tipo: TypeRegistro): Promise<AxiosResponse<TypeRegistro[]>> {
        return Axios.post<TypeRegistro[]>(`PlanoContasTipo/listarClassificacao`, tipo);
    }
}